var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseBtnAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 165,
    rx: 78.6777,
    fill: "#4D7AFF",
    fillOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 122.727,
    height: 122.727,
    rx: 61.3636,
    fill: "#4D7AFF",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pauseBtnAudioID)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.998 70.374V96.6203L96.6202 83.4972L75.998 70.374Z",
    fill: "#4D7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pauseBtnAudioID"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.9937,
    height: 44.9937,
    fill: "white",
    transform: "translate(61 61)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBtnAudio);
export default __webpack_public_path__ + "static/media/pauseBtnAudio.61e6f8824526cfe46d68a3d02c616a82.svg";
export { ForwardRef as ReactComponent };